import React from 'react';

export default class ScrollablePanel extends React.Component {

  render() {
    const { className, children } = this.props;

    return (
      <div className={(className || '') + ' scroll-natif'}>
        {
          children
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./book/src/commons/components/scroll/ScrollablePanel.jsx